<template>
    <!--未购买视频列表-->
    <dd>
      <a v-for="(item, index) in videoList" :key="index">
        <h6>{{item.name}}</h6>
        <p>{{item.date_start}}</p>
      </a>
    </dd>
</template>

<script>
export default {
  name: 'ClassDetailVideoList',
  data () {
    return {
      videoList: {}
    }
  },
  props: [
    'class_id',
    'course_id'
  ],
  mounted () {
    this.getVideoList()
  },
  methods: {
    getVideoList () {
      let data = {
        class_id: this.class_id,
        course_id: this.course_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_timetable',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            console.log('课程列表：')
            console.log(res)
            this.videoList = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/class/ClassDetailVideoList.vue